/* Bravado Labs prototype behaviour.
   Data first (themes, products, chapters), then: intro, smooth scroll, theme switching,
   hero rotation, journey, lineup. Claims follow the product labels and Amazon listings (PRODUCTS.md). */
(() => {
  const THEMES = {
    brand:     { bg: "#dcebec", ink: "#014f58", soft: "#c3dfe1" },
    histamine: { bg: "#d7ece1", ink: "#00573f", soft: "#bfe0cf" },
    hrp:       { bg: "#f4dedd", ink: "#8a161c", soft: "#ecc5c3" },
    cream:     { bg: "#dbe4f6", ink: "#0b3784", soft: "#c2d2ef" },
    delay:     { bg: "#dfe6ee", ink: "#23405f", soft: "#c9d5e3" },
    lido:      { bg: "#dde3f3", ink: "#1d3f8f", soft: "#c6d1ee" },
    cologne:   { bg: "#d8ecea", ink: "#05605d", soft: "#bfe0dd" },
    libido:    { bg: "#ebdff0", ink: "#5d2a72", soft: "#dcc6e6" },
  };
  const ACCENT = "#faa71b";

  const HERO = [
    { name: "Histamine Block", theme: "histamine", img: (window.BL.img + "histamine.webp"), alt: "Bravado Labs Histamine Block, 30,000 HDU",
      stack: ["Enjoy", "every", "meal"], sub: "DAO enzyme support for digesting food histamine. 30,000 HDU per serving.",
      rating: "4.3 on Amazon", note: "Our #1 seller",
      badges: [["30K", "HDU per serving"], ["+C", "Vitamin C"], ["USA", "Made in"]] },
    { name: "HRP RX", theme: "hrp", img: (window.BL.img + "hrp.webp"), alt: "Bravado Labs HRP RX Immune Health Support, 120 capsules",
      stack: ["Immune", "health", "support"], sub: "L-Lysine with vitamin C, zinc, selenium and echinacea. Two capsules a day.",
      rating: "4.3 · 1,794 ratings", note: "Most reviewed",
      badges: [["975", "mg per serving"], ["16", "ingredients"], ["Vegan", "non-GMO"]] },
    { name: "Penile Health Cream", theme: "cream", img: (window.BL.img + "penile-cream.webp"), alt: "Bravado Labs Penile Health Creme, 4 fl oz",
      stack: ["Care", "most men", "skip"], sub: "Fragrance-free daily cream for intimate skin. Absorbs fast, never greasy.",
      rating: "4.0 · 1,400+ ratings", note: "Fan favourite",
      badges: [["4 oz", "about 3 months"], ["0", "fragrance"], ["CoQ10", "+ vitamins"]] },
  ];

  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = document.documentElement;
  const mol = new Molecule($("#molecule"));
  /* the hexagon field belongs to the main banner: fade it out once the shopper scrolls past it */
  const heroWrap = $(".hero-scroll");
  if (heroWrap) new IntersectionObserver(([e]) => document.body.classList.toggle("past-hero", !e.isIntersecting), { rootMargin: "0px 0px -60% 0px" }).observe(heroWrap);
  const hasGsap = !!window.gsap;
  if (hasGsap) gsap.registerPlugin(ScrollTrigger);

  /* theme switching: tween the four color tokens + the molecule */
  let current = "";
  function applyTheme(name, shape, force) {
    if (document.body.matches(".pdp-open, .page-open") && !force) return;
    const t = THEMES[name] || THEMES.brand;
    if (shape) mol.setShape(shape);
    if (name === current) return;
    current = name;
    mol.setTheme({ ink: t.ink, accent: ACCENT });
    const vars = { "--bg": t.bg, "--ink": t.ink, "--soft": t.soft };
    if (hasGsap && !reduce) gsap.to(root, { ...vars, duration: 0.9, ease: "power2.out", overwrite: "auto" });
    else Object.entries(vars).forEach(([k, v]) => root.style.setProperty(k, v));
  }

  window.bravadoTheme = (name, force) => applyTheme(name, null, force);
  window.bravadoThemes = THEMES;
  window.bravadoInk = (name) => ({ ink: (THEMES[name] || THEMES.brand).ink, accent: ACCENT });
  const PDPK = { histamine: "histamine", hrp: "hrp", cream: "cream" };

  /* hero rotation */
  const heroImg = $(".hero-img"), stack = $$(".stack span"), sub = $(".hero-sub"), ratingText = $(".hero .rating-text"),
        noteText = $(".note-hero .note-text"), badges = $(".badges"), dots = $(".hero-dots");
  let heroIdx = 0, heroTimer = null, heroInView = true, dir = 1, lenis = null;
  HERO.forEach((h, i) => {
    const b = document.createElement("button"); b.type = "button"; b.setAttribute("role", "tab");
    b.setAttribute("aria-label", h.alt); b.textContent = h.name; b.style.setProperty("--tc", THEMES[h.theme].ink);
    b.onclick = () => { go(i); }; dots.appendChild(b);
  });
  function placeBadges(h) {
    badges.innerHTML = "";
    const pos = innerWidth < 641 ? [[0, 0], [0, 0], [0, 0]] : [[-34, 16], [-34, 44], [-34, 72]]; // a column beside the product, never over it
    h.badges.forEach(([big, small], i) => {
      const li = document.createElement("li");
      li.innerHTML = `${big}<small>${small}</small>`;
      li.style.left = pos[i][0] + "%"; li.style.top = pos[i][1] + "%";
      badges.appendChild(li);
      if (hasGsap && !reduce) {
        gsap.from(li, { scale: 0, rotate: -40, duration: 0.7, delay: 0.25 + i * 0.09, ease: "back.out(1.8)" });
        gsap.to(li, { y: "+=10", duration: 2.4 + i * 0.4, yoyo: true, repeat: -1, ease: "sine.inOut", delay: i * 0.3 });
      }
    });
  }
  function showHero(i) {
    heroIdx = i; const h = HERO[i];
    $$("button", dots).forEach((b, j) => b.setAttribute("aria-selected", j === i));
    if (heroInView) applyTheme(h.theme, "hero");
    $("#hero").dataset.theme = h.theme;
    const swap = () => {
      heroImg.src = h.img; heroImg.alt = h.alt;
      stack.forEach((s, j) => (s.textContent = h.stack[j]));
      sub.textContent = h.sub; ratingText.textContent = h.rating; noteText.textContent = h.note;
      const sn = document.querySelector(".hero-cta .pill"); if (sn) sn.setAttribute("href", `#product-${PDPK[h.theme]}`);
      placeBadges(h);
    };
    if (!hasGsap || reduce) return swap();
    const ready = preloaded[i].decode().catch(() => {});
    gsap.killTweensOf(".hero-prod");
    gsap.to(".hero-prod", { opacity: 0, x: -dir * 160, rotate: -dir * 10, duration: 0.3, ease: "power2.in" });
    gsap.to([".stack span", ".hero-sub"], { opacity: 0, y: -24, duration: 0.3, stagger: 0.03, ease: "power2.in",
      onComplete: () => ready.then(() => {
        swap();
        gsap.fromTo(".hero-prod", { opacity: 0, x: dir * 160, y: 20, rotate: dir * 10, scale: 0.9 }, { opacity: 1, x: 0, y: 0, rotate: 0, scale: 1, duration: 0.9, ease: "expo.out" });
        gsap.fromTo([".stack span", ".hero-sub"], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.7, stagger: 0.07, ease: "expo.out", delay: 0.05 });
      }) });
  }
  const preloaded = HERO.map((h) => { const im = new Image(); im.src = h.img; return im; });
  function restartHero() {}  /* scroll drives the hero now; no autoplay */

  /* visitor control: arrows, drag or swipe the product, keyboard; colour follows instantly */
  const wrap = $(".hero-scroll");
  const pinned = () => !reduce && wrap.offsetHeight > innerHeight * 1.5;
  /* phones: the stacked banner can be taller than the screen, so it pins once its bottom reaches the bottom of the screen
     (sticky with a negative top) and two screens of scroll drive the three products. Desktop pins at the top as before. */
  const heroEl = $(".hero"), canvasEl = $("#molecule");
  let hTop = 0;
  const phone = () => innerWidth < 641 && !reduce;
  const fitHero = () => {
    if (!phone()) { hTop = 0; wrap.style.height = heroEl.style.top = canvasEl.style.transform = ""; mol.setCenter(null); return; }
    /* start the banner below the real header (it is taller with larger phone text settings) */
    document.documentElement.style.setProperty("--hdr", Math.ceil($(".nav").getBoundingClientRect().bottom) + "px");
    let hh = heroEl.offsetHeight;
    /* shorter phones / larger text: shrink the product photo until the whole banner fits under the header */
    if (hh > innerHeight && !heroEl.classList.contains("tight")) { heroEl.classList.add("tight"); hh = heroEl.offsetHeight; }  /* first: drop the description line, smaller badges */
    const over = hh - innerHeight;
    if (over > 0) { const ih = $(".hero-img").offsetHeight, nh = Math.max(170, ih - over - 2); if (nh < ih) { heroEl.style.setProperty("--himg", nh + "px"); hh = heroEl.offsetHeight; } }
    hTop = Math.min(0, innerHeight - hh);
    heroEl.style.top = hTop + "px";
    wrap.style.height = hh + innerHeight * 2 + "px";
    /* hexagons sit behind the top of the product, where it shows above the bottle/jar */
    const img = $(".hero-img").getBoundingClientRect(), hr = heroEl.getBoundingClientRect();
    const yPinned = hTop + (img.top - hr.top) + img.height * .14;
    mol.setCenter({ cx: Math.min(.86, (img.right + 10) / innerWidth), cy: yPinned / innerHeight, n: 11 });  /* top-right of the product, clear of the badges */
    follow();
  };
  /* the field is fixed to the screen; on phones it travels with the banner until it pins */
  const follow = () => { if (!phone()) return; canvasEl.style.transform = `translateY(${(heroEl.getBoundingClientRect().top - hTop).toFixed(1)}px)`; };
  const span = () => wrap.offsetHeight - (phone() ? heroEl.offsetHeight : innerHeight);
  /* jump: scroll to the product's step (the scroll handler then shows it) */
  function go(i, d) { const n = Math.max(0, Math.min(HERO.length - 1, i));
    if (!pinned()) { if (n === heroIdx) return; dir = d || (n > heroIdx ? 1 : -1); showHero(n); return; }
    const top = wrap.getBoundingClientRect().top + scrollY, y = top - hTop + span() * ((n + .5) / HERO.length);
    lenis ? lenis.scrollTo(y, { duration: 1.1 }) : scrollTo({ top: y, behavior: "smooth" }); }
  /* scroll: the hero holds while the visitor scrolls through the three best sellers */
  const onScroll = () => { follow(); if (!pinned()) return; const r = wrap.getBoundingClientRect();
    const p = Math.max(0, Math.min(.9999, (hTop - r.top) / span())), n = Math.floor(p * HERO.length);
    wrap.style.setProperty("--hp", p.toFixed(4));
    if (n !== heroIdx) { dir = n > heroIdx ? 1 : -1; showHero(n); } };
  addEventListener("scroll", onScroll, { passive: true });
  addEventListener("resize", () => { heroEl.style.removeProperty("--himg"); heroEl.classList.remove("tight"); requestAnimationFrame(fitHero); });
  addEventListener("load", fitHero); requestAnimationFrame(fitHero);
  { const ro = new ResizeObserver(() => requestAnimationFrame(fitHero)); ro.observe(heroEl); ro.observe($(".nav")); }  /* fonts, images and copy changes alter the banner height */
  $(".hp-prev").onclick = () => go(heroIdx - 1, -1); $(".hp-next").onclick = () => go(heroIdx + 1, 1);
  const stageEl = $(".hero-stage"); let dx0 = null, dmove = 0;
  stageEl.addEventListener("dragstart", (e) => e.preventDefault());
  stageEl.addEventListener("pointerdown", (e) => { if (e.target.closest("button")) return; dx0 = e.clientX; dmove = 0; stageEl.setPointerCapture(e.pointerId); stageEl.classList.add("grab"); clearInterval(heroTimer); });
  stageEl.addEventListener("pointermove", (e) => { if (dx0 === null) return; dmove = e.clientX - dx0; if (hasGsap) gsap.set(".hero-prod", { x: dmove * .9, rotate: dmove * .03 }); });
  const drop = () => { if (dx0 === null) return; dx0 = null; stageEl.classList.remove("grab");
    if (Math.abs(dmove) > 60) go(heroIdx + (dmove < 0 ? 1 : -1), dmove < 0 ? 1 : -1);
    else { if (hasGsap) gsap.to(".hero-prod", { x: 0, rotate: 0, duration: .6, ease: "expo.out" }); restartHero(); } };
  stageEl.addEventListener("pointerup", drop); stageEl.addEventListener("pointercancel", drop);
  stageEl.addEventListener("keydown", (e) => { if (e.key === "ArrowRight") { e.preventDefault(); go(heroIdx + 1, 1); } if (e.key === "ArrowLeft") { e.preventDefault(); go(heroIdx - 1, -1); } });
  let wAcc = 0, wT = 0;
  stageEl.addEventListener("wheel", (e) => { if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; e.preventDefault(); wAcc += e.deltaX; const now = performance.now();
    if (Math.abs(wAcc) > 50 && now - wT > 500) { go(heroIdx + Math.sign(wAcc), Math.sign(wAcc)); wAcc = 0; wT = now; } }, { passive: false });
  /* autoplay waits while the visitor is engaging with the hero */

  /* hero product follows the cursor a little */
  if (!reduce) addEventListener("pointermove", (e) => {
    if (!heroInView || !hasGsap || dx0 !== null) return;
    const x = e.clientX / innerWidth - 0.5, y = e.clientY / innerHeight - 0.5;
    gsap.to(".hero-img", { x: x * 24, y: y * 16, rotate: x * 5, duration: 0.8, ease: "power3.out", overwrite: "auto" });
  });

  new IntersectionObserver(([x]) => { heroInView = x.isIntersecting; if (heroInView) applyTheme(HERO[heroIdx].theme, "hero"); }, { threshold: .35 }).observe($("#hero"));

  /* smooth scroll + scroll-driven theme */
  lenis = null;
  if (hasGsap && window.Lenis && !reduce) {
    lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.bravadoLenis = lenis;
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add((t) => lenis.raf(t * 1000)); gsap.ticker.lagSmoothing(0);
  }
  $$('a[href^="#"]').forEach((a) => a.addEventListener("click", (e) => {
    if (a.getAttribute("href").startsWith("#product-")) return;
    if (document.body.matches(".pdp-open, .page-open")) return; // a sub-page is open: the router closes it, then scrolls
    const el = $(a.getAttribute("href")); if (!el) return;
    e.preventDefault(); lenis ? lenis.scrollTo(el, { offset: -20 }) : el.scrollIntoView({ behavior: reduce ? "auto" : "smooth" });
  }));

  if (hasGsap) {
    $$("[data-theme]").forEach((el) => {
      if (el === document.body) return;
      ScrollTrigger.create({
        trigger: el, start: "top 55%", end: "bottom 55%",
        onToggle: (s) => { if (s.isActive) applyTheme(el.dataset.theme, el.dataset.shape); },
      });
    });


  }

  /* intro: once per visit, skippable */
  const intro = $("#intro");
  let seen = false; try { seen = sessionStorage.getItem("bl-intro") === "1"; } catch (e) {}
  function endIntro() {
    intro.classList.add("done"); try { sessionStorage.setItem("bl-intro", "1"); } catch (e) {}
    showHero(0); restartHero();
  }
  if (seen || reduce || !hasGsap) { endIntro(); }
  else {
    applyTheme("brand", "hero");
    const tl = gsap.timeline({ onComplete: endIntro });
    tl.to(".intro-logo", { clipPath: "inset(0 0% 0 0)", duration: 1.0, ease: "power3.inOut" })
      .to(".intro-logo", { scale: 1.9, duration: 0.6, ease: "power3.in" }, "+=0.25")
      .to(intro, { opacity: 0, duration: 0.35 }, "<0.3");
    $(".intro-skip").onclick = () => { tl.kill(); endIntro(); };
  }
})();
